
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './App.css';
import nexusLogo from './assets/droitfacil.png';


export default function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const reference = searchParams.get('reference');
    const [status, setStatus] = useState('LOADING');
    const [details, setDetails] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!reference) {
            setError('Aucune référence de paiement trouvée.');
            setStatus('ERROR');
            return;
        }
        fetch(`https://api.droitfacile.net/getTransaction.php?reference=${reference}`)
            .then(async (res) => {
                const data = await res.json();
                return data;
            })
            .then((data) => {
                setDetails(data);
                setStatus(data.status);
            })
            .catch((err) => {
                setError(err.message);
                setStatus('ERROR');
            });
    }, [reference]);

    let title, message, color, icon;
    if (status === 'LOADING') {
        title = 'Vérification du paiement...';
        message = 'Merci de patienter pendant la vérification.';
        color = '#6e8dff';
        icon = '⏳';
    } else if (status === 'SUCCESSFUL') {
        title = 'Paiement validé !';
        message = 'Merci, votre paiement a été confirmé.';
        color = '#27d726';
        icon = '✅';
    } else if (status === 'PENDING') {
        title = 'Paiement en attente';
        message = 'Votre paiement est en cours de traitement. Merci de patienter.';
        color = '#ffd600';
        icon = '⌛';
    } else if (status === 'FAILED' || status === 'ERROR') {
        title = 'Échec du paiement';
        message = error || 'Votre paiement n’a pas pu être validé.';
        color = '#d72638';
        icon = '❌';
    }

    return (
        <div className="page-shell">
            <div className="aurora aurora-a" />
            <div className="aurora aurora-b" />
            <header className="site-header is-visible" style={{position:'static',transform:'none',opacity:1,marginBottom:'2.5rem'}}>
                <div className="brand-wrap">
                    <img className="brand-logo" src={nexusLogo} alt="Logo Nexus Africa" />
                    <span className="brand-name">Droit Facile</span>
                </div>
            </header>
            <main style={{display:'flex',justifyContent:'center',alignItems:'center',minHeight:'60vh'}}>
                <section className="card-panel" style={{maxWidth:480,margin:'0 auto',padding:'2.5rem 2rem',textAlign:'center'}}>
                    <div style={{fontSize:'2.5rem',marginBottom:'0.7rem',color}}>{icon}</div>
                    <h1 style={{margin:'0 0 0.7rem 0',fontFamily:'Bebas Neue, sans-serif',fontSize:'2.3rem',letterSpacing:'0.03em',color}}>{title}</h1>
                    <p style={{color:'#b7c3e0',marginBottom:'1.2rem'}}>{message}</p>
                    {/* {details && <pre style={{textAlign:'left',background:'rgba(20,28,44,0.7)',borderRadius:10,padding:'1rem',fontSize:'0.98rem',color:'#eaf0ff',overflowX:'auto'}}>{JSON.stringify(details, null, 2)}</pre>} */}
                    <a href="/" className="solid-btn" style={{marginTop:'1.5rem',display:'inline-block'}}>Retour à l'accueil</a>
                </section>
            </main>
        </div>
    );
}
